import { render } from "./CancelamentosAdminView.vue?vue&type=template&id=3a7f95d9&scoped=true"
import script from "./CancelamentosAdminView.vue?vue&type=script&lang=js"
export * from "./CancelamentosAdminView.vue?vue&type=script&lang=js"

import "./CancelamentosAdminView.vue?vue&type=style&index=0&id=3a7f95d9&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a7f95d9"]])

export default __exports__